<template>
  <div>
    <top-message />
    <div class="header">
      <div class="top">
        <div class="box">
          优惠券
        </div>
      </div>
      <div class="list">
        <div class="left">
          <div class="img">
            <img
              src="../../assets/images/cardimg.png"
              alt=""
            >
          </div>
          <div class="text">
            <span class="topBox">春节惠企大礼包</span>
            <span class="btn">使用时间：2022.01.12至2022.01.28</span>
          </div>
        </div>
        <div class="right">
          <el-button
            style="border-radius:12px;"
            type="primary"
          >礼包详情</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopMessage from "@/components/TopMessage";
export default {
  components: { TopMessage },
  data () {
    return {}
  },
  methods: {
  }
}
</script>
<style lang='less' scoped>
.header {
  min-height: 880px;
  background-color: #fff;
  margin-top: 10px;
  border-radius: 8px;
  .top {
    height: 60px;
    border-bottom: 1px solid #f3f4f9;
    display: flex;
    align-items: center;
    .box {
      height: 30px;
      font-size: 24px;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #2981ee;
      padding-left: 15px;
      border-left: 5px solid #2981ee;
    }
  }
  .list {
    margin-left: 20px;
    padding-right: 20px;
    height: 100px;
    border-bottom: 1px solid #f3f4f9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    .left {
      display: flex;
      align-items: center;
      img {
        width: 80px;
        height: 80px;
      }
      .text {
        display: flex;
        flex-direction: column;
        .topBox {
          font-size: 18px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #2a2a2a;
        }
        .btn {
          font-size: 14px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #2a2a2a;
          margin-top: 8px;
        }
      }
    }
  }
}
</style> 